module.exports = __webpack_public_path__ + "static/media/mysore-helicopter.e29a2c80.jpg";